export const capitalize = (value: string): string => {
  return typeof value === 'string' && value.length > 0
    ? value.replace(/^\w/, (c) => c.toUpperCase())
    : ''
}
